import React from 'react';
import { useLocation, useParams, Navigate } from 'react-router-dom';
import { TicketSelectionPanel } from '../components/TicketSelectionPanel';
import { isEventBookingEnabled } from '../utils/eventBookingConfig';

export default function TicketSelection() {
  const { eventId: urlEventId } = useParams();
  const location = useLocation();
  const event = location.state?.event ?? null;
  const eventId = urlEventId || location.state?.eventId || event?.id || event?.eventId;

  if (!isEventBookingEnabled()) {
    return <Navigate to={eventId ? `/event/${eventId}` : '/events'} replace />;
  }

  if (!eventId) {
    return <Navigate to="/events" replace />;
  }

  return (
    <TicketSelectionPanel
      layout="page"
      resolvedEventId={eventId}
      initialEvent={event}
    />
  );
}
